module.exports = __webpack_public_path__ + "img/6.61f87d6e.jpg";